// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__4L5yh","toggle":"styles_toggle__2L1KK","preview":"styles_preview__FK4-U"};